module.exports = __webpack_public_path__ + "media/tyuk_m.6f45f1aa.mp3";